// @flow

//
// React
//
import React from 'react';

import {
    createTextCellRenderer,
} from '../../../trix-web-components-table';

const createChatMessageContentTableColumn = (cfg: any): any => {
    return {
        align: 'left',
        flex: true,
        width: 400,

        renderCell: createTextCellRenderer({
            ...cfg.cellRendererFactoryProps,

            getItem: (props: any) => {
                return (props.value) ? props.value.name : '';
            },
        })
    }
}
export default createChatMessageContentTableColumn;